import { useState, useEffect } from "react";

export const useScrollDetection = ({
  innerRef,
  outerRef,
}: {
  innerRef: React.RefObject<HTMLDivElement>;
  outerRef: React.RefObject<HTMLDivElement>;
}) => {
  const [isScrollActive, setIsScrollActive] = useState(false);

  useEffect(() => {
    const checkScrollStatus = () => {
      const outerElement = outerRef.current;
      const innerElement = innerRef.current;

      if (!outerElement || !innerElement) {
        setIsScrollActive(false);
        return;
      }

      const hasScroll = innerElement.scrollHeight > outerElement.clientHeight;
      setIsScrollActive(hasScroll);
    };

    const handleResize = () => {
      checkScrollStatus();
    };

    // Initial check
    checkScrollStatus();

    // Set up resize listener
    window.addEventListener("resize", handleResize);

    // Set up ResizeObserver to watch for content changes
    const resizeObserver = new ResizeObserver(() => {
      checkScrollStatus();
    });

    if (outerRef.current) {
      resizeObserver.observe(outerRef.current);
    }
    if (innerRef.current) {
      resizeObserver.observe(innerRef.current);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      resizeObserver.disconnect();
    };
  }, [innerRef, outerRef]);

  return isScrollActive;
};
